import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SendNotification from "../../components/Notification/SendNotification";
import EditFeatureRequestPage from "../../components/Feature Request/EditFeatureRequestPage";


const UpdateFeatureRequest = () => {
    return (
        <>

            {/* MasterLayout */}
            <MasterLayout>
                <Breadcrumb id="title" title2="Feature Requests" link2="/feature-requests" title="Edit Feature Request" />
                <EditFeatureRequestPage />
            </MasterLayout>

        </>
    );
};

export default UpdateFeatureRequest; 
